exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sign-up-page .section-title{padding:16px 0;font-weight:700;font-size:16px;color:#0096d6}.sign-up-page .admin-help{background-color:rgba(0,150,214,.3);padding:4px;border-radius:5px;margin-bottom:4px}.sign-up-page .panel-content .form-container.signup md-input-container{min-height:35px;width:100%}.sign-up-page .panel-content .form-container.signup md-input-container.sub-linked{margin-bottom:0}.sign-up-page .panel-content .form-container.signup .md-errors-spacer{display:none}.sign-up-page .help-icon{margin-left:6px;color:#5a5a5a;cursor:pointer;user-select:none}.sign-up-page .help-text{border-radius:5px;padding:8px;background-color:#e5e8e8;margin-bottom:8px}.sign-up-page .help-text .help-title{font-weight:700;margin-bottom:4px}.sign-up-page .help-text .help-section{margin-top:4px}.sign-up-page .captcha-container{height:66px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/sign-up/sign-up.scss
// module id = 140
// module chunks = 0